<template>
    <article
        class="i-reporting-and-results"
        :class="{
            large: reportingAndResultsData.large,
            fullRow: reportingAndResultsData.fullRow,
            small: reportingAndResultsData.small
        }">
        <div
            class="i-reporting-and-results__container"
            :class="reportingAndResultsData.labelBgColor ? 'textColorBlack' : ''"
            :style="{backgroundColor: reportingAndResultsData.labelBgColor}">     
            <h2
                class="i-reporting-and-results__title"
                :title="reportingAndResultsData.header"
                v-html="reportingAndResultsData.header"></h2>
            <div class="i-reporting-and-results__wrap">
                <p
                    v-if="reportingAndResultsData.desc"
                    class="i-reporting-and-results__desc"
                    v-html="reportingAndResultsData.desc"></p>
                <a
                    v-if="reportingAndResultsData.link"
                    class="arrow-btn"
                    :class="reportingAndResultsData.labelBgColor ? '' : 'whiteBtn'"
                    :href="reportingAndResultsData.link"
                    :target="reportingAndResultsData.link.includes('://') ? '_blank' : '_self'"></a>
            </div>
        </div>
        <div
            v-if="reportingAndResultsData.picture"
            class="i-reporting-and-results__img">
            <picture-helper
                :picture-data="reportingAndResultsData.picture" />
        </div>
    </article>
</template>

<script>
    import PictureHelper from '../helpers/PictureHelper'

    export default {
        name: 'ReportingAndResults',
        components: {
            PictureHelper
        },
        props: {
            reportingAndResultsData: {
                type: Object,
                default: () => {}
            }
        }
    }
</script>